import Box from '@mui/material/Box'
import Header from './Header'
import { Outlet } from 'react-router-dom'
import SideBar from './SideBar'
import * as React from 'react'
import { CssBaseline } from '@mui/material'
import NewSidebar from "./NewSideBar";
import {useContext, useMemo} from "react";
import Context from "../../contexts/Context";
import {getCashFlow, hasFeature} from "../../services/Main/AuthStorage";
import AIAssistant from "../../components/AIAssistant/AIAssistant";
import TicketPendingAlert from "../../components/Ticket/TicketPendingAlert";

const drawerWidth = 250

const Base = () => {
  const [mobileMenu, setMobileMenu] = React.useState(false)

  const { user, managerMode } = useContext(Context)

    const newMenu = useMemo(() => {
        const result = getCashFlow();
        return result === 'true';
    }, [getCashFlow()]);

    const isFinancialMode = managerMode === 'financial'
    const financialDrawerWidth = 260
    const currentDrawerWidth = isFinancialMode ? financialDrawerWidth : drawerWidth;
  const handleDrawerToggle = () => {
    setMobileMenu(!mobileMenu)
  }

  return (
    <Box sx={{ display: 'flex', overflow: 'hidden' }}>
      <CssBaseline/>
        {isFinancialMode ?
            <NewSidebar mobileMenu={mobileMenu} handleDrawerToggle={handleDrawerToggle} />
            :
            <SideBar mobileMenu={mobileMenu} handleDrawerToggle={handleDrawerToggle}/>
        }

      <Box
        component="main"
        sx={(theme) => ({
          flexGrow: 1,
          width: { md: `calc(100% - ${currentDrawerWidth}px)` },
          overflow: 'auto',
          minHeight: '100%',
          paddingBottom: theme.spacing(10),
          [theme.breakpoints.up('lg')]: {
            paddingTop: theme.spacing(3),
          }
        })}
      >
        <Header handleDrawerToggle={handleDrawerToggle}/>
        <Outlet/>
      </Box>
      {hasFeature('chat_ai') && <AIAssistant />}
      <TicketPendingAlert />
    </Box>
  )
}
export default Base